<div class="form-group">
  <!-- search -->
  <div #searchContainer [ngClass]="{'active' : showMyContainer}" class="div select-bg search-container"
    style="display: block;">
    <input type="text" readonly class="search"
      style="height: 44px; display: block; width: 100%; padding-left: 12px;" (click)="openDropdown()"
      name="selectedOption" [(ngModel)]="selectedOption">
    <div *ngIf="showClearFIlter" class="clear-filter" (click)="selectOption(null)">X</div>
    <div class="show-list" *ngIf="showMyContainer">
      <div class="backdrop" (click)="openDropdown()"></div>
      <div style="z-index: 100; overflow-y: auto;">
        <div class="divider"></div>
        <input type="text" class="search-marke" (input)="filterOptions()" [attr.placeholder]="'global.search' | translate"
          name="searchTerm" name="searchTerm" [(ngModel)]="searchTerm">
        <ul style="margin-bottom: 12px;">
          <li *ngFor="let company of filteredOptions" [ngClass]="{'active': selectedOption === company.name}" (click)="selectOption(company)">
            {{ company.name }}
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
